import Header from './components/Header';
import Hero from './components/Hero';
import SectionApp from './components/SectionApp';
import SectionUpdates from './components/SectionUpdates';
import SectionIndex from './components/SectionIndex';
import SectionContact from './components/SectionContact';
import SectionCarousel from './components/SectionCarousel';
import SectionFeatures from './components/SectionFeatures';
import SectionRanking from './components/SectionRanking';
import SectionMedia from './components/SectionMedia';
import SectionFaq from './components/SectionFaq';
import SectionComments from './components/SectionComments';
import SectionCards from './components/SectionCards';
import SectionAbout from './components/SectionAbout';
import SectionTopics from './components/SectionTopics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <Header />
      <main>
        <Hero />
        <SectionApp />
        <SectionUpdates />
        <SectionIndex />
        <SectionContact />
        <SectionCarousel />
        <SectionFeatures />
        <SectionRanking />
        <SectionMedia />
        <SectionFaq />
        <SectionComments />
        <SectionCards />
        <SectionAbout />
        <SectionTopics />
      </main>
      <Footer />
    </div>
  );
}